import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OMCheckbox from '../../OMComponents/OMCheckbox/OMCheckbox';
import styles from './OMMultiCheckbox.scss';

class OMMultiCheckbox extends Component {
  handleChange = (event, id) => {
    const { onChange, value } = this.props;
    const values = (!!value) ? [...value] : [];
    const checked = event.target.checked;
    const idx = value.indexOf(id);
    const inside = (idx !== -1);

    if (checked && !inside) {
      values.push(id);
    } else if (!checked && inside) {
      values.splice(idx, 1);
    }

    return onChange(values.sort());
  };

  render() {
    const { options, className, customCheckBox, notValid } = this.props;
    const checkboxes = options.map(({ id, label }) => {
      const isChecked = this.props.value.indexOf(id) > -1;
      return (
        <div key={id} className={styles.checkbox}>
          <OMCheckbox
            id={`id-${id}`}
            label={label}
            customCheckBox={customCheckBox}
            notValid={notValid}
            field={{
              value: isChecked,
              checked: isChecked,
              onChange: event => this.handleChange(event, id)
            }}
          />
        </div>
      );
    });

    return (
      <div className={className}>
        {checkboxes}
      </div>
    );
  }
}

OMMultiCheckbox.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  className: PropTypes.string,
  customCheckBox: PropTypes.string,
  notValid: PropTypes.bool
};

export default OMMultiCheckbox;
